<template>
  <div class="flex-1 min-w-0 md:h-full">
    <a-menu
      :mode="direction || 'horizontal'"
      :items="items"
      v-model:openKeys="state.openKeys"
      v-model:selectedKeys="state.selectedKeys"
      @click="handleClick"
      class="w-full justify-center"
      v-if="mode === 'pc'"
    />
    <span class="flex-c h-full text-lg font-medium" v-else>{{ currentTitle }}</span>
  </div>
</template>
<script lang="ts" setup>
import { type MenuProps } from "ant-design-vue";

interface MenuItem {
  key: string;
  label: string;
  path: string;
  icon?: any;
  children?: MenuItem[];
}

const props = withDefaults(
  defineProps<{
    direction?: "horizontal" | "vertical";
    mode?: "pc" | "mobile";
  }>(),
  {
    direction: "horizontal",
    mode: "pc",
  }
);

const router = useRouter();
const state = reactive({
  selectedKeys: [] as string[],
  openKeys: [] as string[],
  preOpenKeys: [] as string[],
});

const { t } = useI18n();
const items = computed<MenuItem[]>(() => {
  return [
    { key: "home", label: t("Home"), path: "/" },
    { key: "pricing", label: t("Pricing"), path: "/pricing" },
    // { key: "blog", label: t("layout.menu.blog"), path: "/blog" },
    // { key: "whitepaper", label: t("layout.menu.whitepaper"), path: "/whitepaper" },
    // { key: "faq", label: t("layout.menu.faq"), path: "/faq" },
    // { key: "about", label: t("layout.menu.about"), path: "/about" },
  ];
});
const emit = defineEmits(["clicked"]);
const path = computed(() => router.currentRoute.value.path);

const currentTitle = computed(() => {
  if (props.mode === "pc") return null;
  if (path.value === "/terms") return t("layout.menu.terms");
  if (path.value === "/privacy") return t("layout.menu.privacy");
  return items.value.find(v => v.path === path.value)?.label;
});

const handleClick: MenuProps["onClick"] = e => {
  router.push(e.item.path);
  emit("clicked");
  if (e.keyPath?.length !== 1) {
    return true;
  }
};
watch(
  () => state.openKeys,
  (_val, oldVal) => {
    state.preOpenKeys = oldVal;
  }
);
watch(
  () => path.value,
  val => {
    const matchedItem = items.value.find(v => v.path === val);
    if (matchedItem) {
      state.selectedKeys = [matchedItem.key];
    } else {
      state.selectedKeys = [];
    }
  },
  { immediate: true }
);
</script>
<style scoped lang="less">
:deep(.ant-menu-vertical) {
  border-inline-end: none !important;

  .ant-menu-item {
    padding-left: 0;
  }
}
</style>
